import './index.css';
import React, { Fragment } from 'react';
import classnames from 'classnames';
import { formatToTimeZone } from 'date-fns-timezone';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var styles = {"fill-politico-red":"politico_style___2V-fyBu7uk","styles":"politico_style___3ZROY9z821"};

var makeBylines = function makeBylines(authors) {
  var output = authors.slice();
  var lastAuthor = output.pop();
  var secondToLastAuthor = output.pop();
  return React.createElement(Fragment, null, output.map(function (author, i) {
    return React.createElement(Fragment, {
      key: i
    }, React.createElement("a", {
      href: author.link
    }, React.createElement("span", {
      className: "byline",
      dangerouslySetInnerHTML: {
        __html: author.name
      }
    })), ",\xA0");
  }), secondToLastAuthor && React.createElement(Fragment, null, React.createElement("a", {
    href: secondToLastAuthor.link
  }, React.createElement("span", {
    className: "byline",
    dangerouslySetInnerHTML: {
      __html: secondToLastAuthor.name
    }
  })), "\xA0and\xA0"), React.createElement("a", {
    href: lastAuthor.link
  }, React.createElement("span", {
    className: "byline",
    dangerouslySetInnerHTML: {
      __html: lastAuthor.name
    }
  })));
};

var formatDate = function formatDate(date) {
  if (typeof date === 'string') {
    return formatToTimeZone(new Date(date), 'MM/DD/YYYY h:mm A z', {
      timeZone: 'America/New_York'
    });
  } else {
    return '';
  }
};

var Info =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Info, _React$PureComponent);

  function Info() {
    _classCallCheck(this, Info);

    return _possibleConstructorReturn(this, _getPrototypeOf(Info).apply(this, arguments));
  }

  _createClass(Info, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          authors = _this$props.authors,
          published = _this$props.published,
          updated = _this$props.updated;
      return React.createElement("div", {
        className: classnames('info', styles.styles)
      }, React.createElement("p", null, authors && authors.length > 0 && React.createElement("span", {
        className: "authors"
      }, " By ", makeBylines(authors)), published && updated && React.createElement("span", {
        className: "timestamp"
      }, " | ", formatDate(published)), published && !updated && React.createElement("span", {
        className: "timestamp"
      }, " | ", React.createElement("time", {
        dateTime: published
      }, formatDate(published))), updated && React.createElement("span", {
        className: "updated"
      }, " | ", React.createElement("time", {
        dateTime: updated
      }, "Updated ", formatDate(updated)))));
    }
  }]);

  return Info;
}(React.PureComponent);

Info.defaultProps = {
  authors: [],
  published: null,
  updated: null
};

export default Info;
